import React, { useState, useEffect } from "react";
import Popup from "reactjs-popup";
import "../../component/css/users.css";
import { FaSearch } from "react-icons/fa";
import { IoMdMore } from "react-icons/io";
import { useNavigate, Link } from "react-router-dom";
import aang from "../../component/images/aang.jpg";
import No_Users from "../../component/notfound/No_Users";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { ClipLoader } from "react-spinners";
import PageCounter from "../../component/page_counter";
import {
  ClassNameDeterminer,
  NameTrimer,
} from "../../component/content_trimer";
import ClickAwayListener from "react-click-away-listener";

export const ZeroChecker = (cash) => {
  if (cash === 0) {
    return "₦0.00";
  } else {
    return "₦" + cash.toLocaleString();
  }
};

export default function Users() {
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [isLoaded, setIsLoaded] = useState(false);
  const [result, setResult] = useState();
  const [pageCount, setPageCount] = useState(1);
  const [searchString, setSearchString] = useState("");
  const token = JSON.parse(sessionStorage.getItem("userToken"));
  const [disable, setDisable] = useState(false);
  const [disable1, setDisable1] = useState(false);
  const [disable3, setDisable3] = useState(false);
  const [fire, setFire] = useState(false);
  const [search, setSearch] = useState(false);
  const [resultPerPage, setResultPerPage] = useState(20);
  //console.log(token);
  // const [user_id, setUserId] = useState('');

  useEffect(() => {
    const savedPage = parseInt(localStorage.getItem("lastPage")) || 1;
    setPageCount(savedPage); // Update state first

    if (!fire) {
      fetchData(savedPage); // Pass savedPage explicitly
    }
  }, [fire]);

  const minusPagec = () => {
    if (pageCount <= 1) return;

    setDisable(true);
    const pageCountM = pageCount - 1;
    setPageCount(pageCountM);
    localStorage.setItem("lastPage", pageCountM);

    if (search) {
      fetchSearchData(pageCountM);
    } else {
      fetchData(pageCountM);
    }
  };

  const addPagec = () => {
    if (data?.length <= resultPerPage - 1) return;

    setDisable1(true);
    const pageCountM = pageCount + 1;
    setPageCount(pageCountM);
    localStorage.setItem("lastPage", pageCountM);

    if (search) {
      fetchSearchData(pageCountM);
    } else {
      fetchData(pageCountM);
    }
  };


  const handleButtonClick = (e) => {
    e.preventDefault();
    setDisable3(true);
    setFire(false);
    setPageCount(1);
  };

  const DataChecker = (data) => {
    if (data) {
      return data;
    } else {
      return "No Data Yet";
    }
  };

  const fetchData = async (pageCountM = pageCount) => {
    try {
      setSearch(false);
      const response = await fetch("https://serverpickload.wl.r.appspot.com/view_ops/users", {
        method: "POST",
        body: JSON.stringify({
          token,
          pageCount: pageCountM,
          resultPerPage,
        }),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json, text/plain, */*",
        },
      });

      if (!response.ok) throw new Error("Failed to fetch data");

      const resultM = await response.json();
      setResult(resultM);
      setData(resultM.users);
      setIsLoaded(true);
      setFire(true);

      setDisable(false);
      setDisable1(false);
      setDisable3(false);
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };


  const fetchSearchData = async (pageCountM) => {
    try {
      //console.log(searchString);

      const savedPage = localStorage.getItem("lastPage");
      const currentPage = pageCountM || savedPage || pageCount;


      const response = await fetch(
        "https://serverpickload.wl.r.appspot.com/admin_search/users",
        {
          method: "POST",

          body: JSON.stringify({
            token: token,
            pageCount: currentPage,
            search: searchString,
            resultPerPage: resultPerPage,
          }),
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json, text/plain, */*",
          },
        }
      );

      //console.log('got here');
      // setData(await response.json());
      const result = await response.json();
      setData(result.users);
      //console.log(result);
      //console.log(data);
      setResult(result);

      if (result.msg === "Success") {
        //console.log('data gotten succesfully');
        setDisable(false);
        setDisable1(false);
        setDisable3(false);
      } else {
        setData("");
        //console.log('some error occurred');
      }
    } catch (error) {
      //console.log(error);
    }
  };

  const Menu = (user_details) => (
    <div className="admin-App">
      <Popup
        trigger={
          <button className="more-details">
            {" "}
            <IoMdMore />{" "}
          </button>
        }
        position="right top"
        on="click"
        closeOnDocumentClick
        mouseLeaveDelay={300}
        mouseEnterDelay={0}
      // contentStyle={{ padding: '0px', border: 'none' }}
      // arrow={false}
      >
        <ul className="drop-down2">
          <li
            onClick={() => {
              localStorage.setItem("lastPage", pageCount)
              navigate("/App/Individual_user", {
                state: { id: user_details._id },
              })
            }
            }
          >
            View User's profile
          </li>
          <li
            onClick={() => {
              localStorage.setItem("lastPage", pageCount)
              navigate("/App/Message_User", {
                state: { user_details: user_details },
              })
            }
            }
          >
            Message User
          </li>
          <li
            onClick={() => {
              localStorage.setItem("lastPage", pageCount)
              navigate("/App/Block_User", { state: { id: user_details._id } })
            }
            }
          >
            Block User
          </li>
          <li
            onClick={() => {

              navigate("/App/Delete_User", {
                state: { id: user_details._id, email: user_details.email },
              })
            }
            }
          >
            Delete User
          </li>
        </ul>
      </Popup>
    </div>
  );

  if (!isLoaded) {
    return (
      <h1 className="loading-pages">
        {" "}
        <ClipLoader color={"#1FAA08"} size={100} />
      </h1>
    );
  } else if (data?.length > 0) {
    return (
      <div className="users">
        <div className="users-properties">
          <h1 className="users-title">Users</h1>
          <div className="users-table-display">
            <div className="users-search-box-container">
              <div className="main-search-box-container">
                <input
                  type="text"
                  placeholder="Search Users"
                  className="search-box"
                  value={searchString}
                  onChange={(e) => setSearchString(e.target.value)}
                />
                <button className="delivery-searching">
                  <FaSearch
                    onClick={() => {
                      fetchSearchData();
                      setSearch(true);
                      setPageCount(1);
                    }}
                  />
                </button>
              </div>
              <div>
                <Link to="/App/Blocked_Users">
                  {" "}
                  <button className="delivery-agent-block">
                    View blocked List
                  </button>
                </Link>
              </div>
            </div>

            <div className="result-per-page">
              <form>
                Results per page
                <input
                  className="chizys-input"
                  type="number"
                  value={resultPerPage}
                  onChange={(e) => setResultPerPage(e.target.value)}
                />
                <button
                  className="chizys-button"
                  disabled={disable3}
                  onClick={handleButtonClick}
                >
                  Done
                </button>
              </form>
            </div>
            <table className="users-table">
              <th>
                <div className="agent-table-left">Picture</div>
              </th>
              <th>Full name</th>
              <th>Email address</th>
              <th>Phone number</th>
              <th>Expenditures</th>
              <tbody>
                {data.map((item, i) => (
                  <tr key={i}>
                    <td>
                      <div className="users-table-pic">
                        <img
                          src={item?.img ? item?.img : aang}
                          alt=""
                          className="users-table-pic"
                          style={{ objectFit: "cover" }}
                        />
                      </div>{" "}
                    </td>
                    <td className={ClassNameDeterminer(item?.fullname)}>
                      {NameTrimer(DataChecker(item?.fullname))}
                      <p style={{ display: "none" }}>
                        {DataChecker(item?.fullname)}
                      </p>
                    </td>
                    <td>{item?.email}</td>
                    <td>{"+234" + item?.phone_no}</td>
                    <td>{ZeroChecker(item?.stats?.total_expenditure)}</td>
                    <td>
                      <div className="popup-click">{Menu(item)}</div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div
            style={{
              height: "20px",
              display: "flex",
              alignContent: "center",
              justifyContent: "flex-end",
              paddingRight: "20px",
              marginTop: "10px",
            }}
          >
            <div>
              {disable ? (
                <ClipLoader color={"black"} loading={disable} size={15} />
              ) : (
                <FontAwesomeIcon
                  icon={faAngleLeft}
                  className={pageCount <= 1 ? "icon-space-less" : "icon-space"}
                  onClick={minusPagec}
                />
              )}
            </div>
            <h6>{PageCounter(result.count, pageCount, resultPerPage)}</h6>
            <div>
              {disable1 ? (
                <ClipLoader color={"black"} loading={disable1} size={15} />
              ) : (
                <FontAwesomeIcon
                  icon={faAngleRight}
                  className={
                    data?.length <= resultPerPage - 1
                      ? "icon-space-less"
                      : "icon-space"
                  }
                  onClick={addPagec}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  } else if (data?.length === 0 || data == null || data == undefined) {
    //console.log('and here');
    return <No_Users />;
  }
}
